module.exports = __webpack_public_path__ + "media/flags/to-5f7ede66.svg";